import Excel from 'exceljs';
import FileSaver from 'file-saver';

import filterSet from './filterSet';
import totalSet from './totalSet';
import dataSet from './dataSet';

const titleStyle = (cell, title) => {
  cell.value = title;
  cell.alignment = { vertical: 'middle', horizontal: 'center' };
  cell.font = { bold: true, color: { argb: 'FFFFFF' } };
  cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '0358BD' }};
  cell.border = { bottom: {style:'thin'} };
}

export const excel = async (props) => {
  const { fileName, tableName, filters, totals, dataList } = props;
  let row = 1;

  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet(fileName);

  if(filters) {
    const filterRows = filterSet(tableName, filters);
    worksheet.mergeCells(row, filterRows.headers.length, row, 0);
    titleStyle(worksheet.getCell('A' + row), 'Filtros Aplicados');
    worksheet.addRow(filterRows.headers);
    worksheet.addRow(filterRows.filters);
    
    row += 1;
    filterRows.headers.forEach((h,i) => {
      worksheet.getRow(row).getCell(i+1).font = { 
        bold: true
      };
      worksheet.getRow(row).getCell(i+1).fill = { 
        type: 'pattern', 
        pattern: 'solid', 
        fgColor: { argb: 'AAAAAA' }
      };
      worksheet.getRow(row+1).getCell(i+1).fill = { 
        type: 'pattern', 
        pattern: 'solid', 
        fgColor: { argb: 'E6E6E6' }
      };
    });
    row += 3;
  }
  
  if(totals) {
    const totalRows = totalSet(tableName, totals);
    worksheet.mergeCells(row, totalRows.headers.length, row, 0);
    titleStyle(worksheet.getCell('A' + row), 'Cálculos sobre Importes');
    worksheet.addRow(totalRows.headers);
    worksheet.addRow(totalRows.totals);
    
    row += 1;
    totalRows.headers.forEach((h,i) => {
      worksheet.getRow(row).getCell(i+1).font = { 
        bold: true 
      };
      worksheet.getRow(row).getCell(i+1).alignment = { 
        horizontal: 'right'
      };
      worksheet.getRow(row).getCell(i+1).fill = { 
        type: 'pattern', 
        pattern: 'solid', 
        fgColor: { argb: 'AAAAAA' }
      };
      worksheet.getRow(row+1).getCell(i+1).fill = { 
        type: 'pattern', 
        pattern: 'solid', 
        fgColor: { argb: 'E6E6E6' }
      };
    });
    row += 3;
  }

  if(dataList && dataList.length > 0) {
    const dataRows = dataSet(tableName, dataList);
    worksheet.mergeCells(row, dataRows.headers.length, row, 0);
    titleStyle(worksheet.getCell('A' + row), fileName);
    worksheet.addRow(dataRows.headers);
    worksheet.addRows(dataRows.rows);
    
    dataRows.widths.forEach((w,i) => { 
      worksheet.getColumn(i+1).width = w
    });
    row += 1;
    dataRows.headers.forEach((h,i) => {
      worksheet.getRow(row).getCell(i+1).font = { 
        bold: true 
      }; 
      worksheet.getRow(row).getCell(i+1).fill = { 
        type: 'pattern', 
        pattern: 'solid', 
        fgColor: { argb: 'AAAAAA' }
      };
    });
    row += 1;
    dataRows.rows.forEach((r,rowI) => {
      const color = rowI % 2 ? 'E6E6E6' : 'F2F2F2';
      dataRows.headers.forEach((h,colI) => {
        worksheet.getRow(rowI+row).getCell(colI+1).fill = { 
          type: 'pattern', 
          pattern: 'solid', 
          fgColor: { argb: color }
        };
      });
    });
  }

  /*
  worksheet.autoFilter = {
    from: 'A6',
    to: { 
      row: 6, 
      column: dataRows.headers.length 
    }
  } 
  */

  await workbook.xlsx.writeBuffer()
    .then(buffer => FileSaver.saveAs(new Blob([buffer]), `${fileName} ${Date.now()}.xlsx`));
};